import React, { useState } from "react";
import PropTypes from "prop-types";
import { Menu, MenuItem, Box, CircularProgress } from "@mui/material";
import { CloudDownload, CloudUpload } from "@mui/icons-material";
import MDButton from "components/MDButton"; // Your custom button component
import { useTranslation } from "react-i18next";
import ImportButton from "components/ImportButton";

const ExportMenu = ({ handleExport, handleImportError, downloadLoading, canEdit, companyId }) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (type) => {
    handleExport(type);
    handleClose();
  };

  return (
    <Box display="flex" justifyContent="flex-start" mt={2} gap={2} flexWrap="wrap">
      {/* Export Button */}
      <Box>
        <MDButton
          color="primary"
          onClick={handleClick}
          startIcon={<CloudDownload />}
          sx={{
            "@media (max-width: 600px)": {
              width: "100%",
            },
          }}
          disabled={downloadLoading}
        >
          {downloadLoading ? <CircularProgress size={20} color="inherit" /> : t("export")}
        </MDButton>
        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
          {/* <MenuItem onClick={() => handleSelect("scorecardTemplate")}>
            {t("admin.scorecard.ex")}
          </MenuItem> */}
          <MenuItem onClick={() => handleSelect("Company Kpis")}>
            {t("admin.scorecard.exportCompanyKpis")}
          </MenuItem>
          <MenuItem onClick={() => handleSelect("scorecards")}>
            {t("admin.scorecard.exportScorecard")}
          </MenuItem>
          <MenuItem onClick={() => handleSelect("performance")}>
            {t("admin.scorecard.exportPerformance")}
          </MenuItem>
        </Menu>
      </Box>

      <ImportButton
        // Only allow Jobs to be imported from this page
        allowedTypes={["scorecards"]}
        // Pass context needed for the ImportReview page (optional now, mostly companyId)
        extraState={{
          companyId: companyId,
        }}
        // Handle UI feedback
        onError={handleImportError}
        disabled={!canEdit}
      />
    </Box>
  );
};

// ✅ PropTypes Definition
ExportMenu.propTypes = {
  handleExport: PropTypes.func.isRequired,
  handleImportError: PropTypes.func.isRequired,
  downloadLoading: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
  canEdit: PropTypes.bool.isRequired,
  companyId: PropTypes.number.isRequired,
};

export default ExportMenu;
